<template>
    <v-sheet>
        <span v-if="!subject" class="caption"> 회원 / 설비를 설정해주세요. </span>
        <span v-else-if="item.isOnHoliday"> 운영하지 않는 날짜입니다 </span>
        <span v-else-if="!item.isOnBusiness"> 운영하지 않는 요일입니다 </span>
        <span v-else-if="item.isWholeDayRent">
            <rental-schedule-whole-day-checkbox v-bind="{ loading, schedules, item, date, _user, limitationMet }" v-on="{ add, del: (schedule) => $emit('del', schedule) }" />
        </span>
        <v-row v-else no-gutters class="py-2">
            <v-col lg="4" v-for="time in subject?.businessHours" :key="time">
                <rental-schedule-checkbox v-bind="{ loading, schedules, item, date, _user, time, limitationMet }" v-on="{ add, del: (schedule) => $emit('del', schedule) }" />
            </v-col>
        </v-row>
    </v-sheet>
</template>

<script>
import dayjs from "dayjs";
import RentalScheduleCheckbox from "../console/rental/rental-schedule-checkbox.vue";
import RentalScheduleWholeDayCheckbox from "../console/rental/rental-schedule-whole-day-checkbox.vue";

export default {
    components: {
        RentalScheduleCheckbox,
        RentalScheduleWholeDayCheckbox,
    },
    props: {
        loading: { type: Boolean, default: false },

        date: { type: String, default: Date.now().toDate() },
        _user: { type: String, default: null },
        value: { type: Array, default: () => [] },
        subject: { type: Object, default: null },
        limitationMet: { type: Boolean, default: false },
        schedulesOnCloud: { type: Array, default: () => [] },
    },
    data: () => ({
        schedules: [],
    }),
    computed: {
        dayOfDate() {
            return dayjs(this.date).day();
        },
        item() {
            return {
                ...(this.subject || {}),
                schedulesOnCloud: this.schedulesOnCloud.filter(({ _subject }) => _subject == this.subject?._id),
                isOnBusiness: (this.subject?.businessDays || []).includes(this.dayOfDate),
                isOnHoliday: (this.subject?.holidays || []).some((date) => dayjs(this.date).isSame(date, "date")),
            };
        },
    },
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
        schedules() {
            this.$emit("input", this.schedules);
        },
    },
    methods: {
        sync() {
            this.schedules = this.value;
        },
        add(schedule) {
            this.schedules = this.schedules.concat([schedule]);
        },
    },
};
</script>
